import { useEffect, useState } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { RiFileList3Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { logout } from "../../app/Api";
import { setIsHomeProcess } from "../../app/GlobalSlice";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError, notifySuccess } from "../../utils/Notification";
import { isPhone } from "../../utils/PlatformHelper";
import { getDocuments, uploadDocuments } from "./Api";
import FilePreviewDialog from "./FilePreviewDialog";
import UploadDocumentDialog from "./UploadDocumentDialog";

const DocumentPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {
    member,
    screenSize,
    systemProfile
  } = useSelector(state => state.global)

  useEffect(() => {
    document.body.style.backgroundColor = isPhone(screenSize.width) ? 'white' : '#232745';
  }, [screenSize.width])

  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState([])

  const [documents, setDocuments] = useState([])
  const [toUploadDocs, setToUploadDocs] = useState([])

  const [hashImage, setHashImage] = useState(Date.now());

  const [uploadDocumentDialog, setUploadDocumentDialog] = useState({
    isOpen: false,
    selectedDocument: null
  })

  const [filePreviewDialog, setFilePreviewDialog] = useState({
    isOpen: false,
    selectedData: null
  })

  const [documentTypes, setDocumentTypes] = useState([
    {
      key: 0,
      name: "Dokumen Wajib"
    },
    {
      key: 1,
      name: "Dokumen Tidak Wajib"
    },
  ])

  useEffect(() => {
    document.body.style.backgroundColor = '#232745';
  }, []) 

  useEffect(() => {
    getDocuments()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setDocuments(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {})
  }, [])

  function onUserSelectFile(docId, file) {
    const isExist = toUploadDocs.find(doc => doc.idDocument == docId)

    if (isExist == undefined) {
      setToUploadDocs([...toUploadDocs, { idDocument: docId, file: file }])
    }
    //terjadi perubahan file yang sebelumnya pernah dipilih untuk suatu document id
    else {
      const updated = toUploadDocs.map(doc => doc.idDocument == docId ? { ...doc, file: file } : doc)
      setToUploadDocs(updated)
    }

    setUploadDocumentDialog({
      ...uploadDocumentDialog,
      isOpen: false,
      selectedDocument: null
    })
  }

  function onOpenPreviewFile(docId) {
    const { file } = toUploadDocs.find(d => d.idDocument == docId)
    setFilePreviewDialog({
      ...filePreviewDialog,
      isOpen: true,
      selectedData: file
    })
  }

  function onRemoveSelectedFile(docId) {
    const updated = toUploadDocs.filter(d => d.idDocument != docId)
    setToUploadDocs(updated)
  }

  function onFinish() {
    dispatch(setIsHomeProcess(true))

    uploadDocuments(toUploadDocs)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Unggah Dokumen Berhasil')
            navigate('/home/finish')
          },
          onRecovFailure: errors => setErrors(errors),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  function onLogout() {
    dispatch(setIsHomeProcess(true))

    logout()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Logout Berhasil')
            navigate("/login")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  if (!systemProfile) return null;

  if (member === null) {
    return (
      <div
        className="h-screen"
      >

        <div
          className="py-10 flex justify-center"
        >
          
          <div
            className="relative rounded-sm flex"
            style={{
              width: '650px',
              // height: '700px'
            }}
          >
            
            <div
              className="flex-1 bg-white p-10"
            >
            </div>

          </div>
          

        </div>
      </div>
    )
  }

  return (
    <>
    {uploadDocumentDialog.isOpen && (
      <UploadDocumentDialog
        onClose={() => setUploadDocumentDialog({ ...uploadDocumentDialog, isOpen: false, selectedDocument: null })}
        selectedData={uploadDocumentDialog.selectedDocument}
        onFileSelected={onUserSelectFile}
      />
    )}
    {filePreviewDialog.isOpen && (
      <FilePreviewDialog 
        selectedFile={filePreviewDialog.selectedData}
        onClose={() => setFilePreviewDialog({ ...filePreviewDialog, isOpen: false, selectedData: null })}
      />
    )}
    <div
      className="h-screen"
    >
      <div
        className="py-10 flex justify-center"
      >
        <div
          className="relative rounded-sm flex"
          style={{
            width: isPhone(screenSize.width) ? '100%' : '650px' ,
          }}
        >
          <div
            className="flex-1 bg-white"
          >

            <div
              className="py-5 pt-8 text-center uppercase font-bold" 
              style={{
                fontFamily: 'Nunito',
                fontSize: '20px'
              }}
            >
              <label>Tahap Kelengkapan Dokumen</label>
            </div>
            <div
              className="flex justify-center py-5"
            >
              <img src={systemProfile.companyLogo + '?' + hashImage} width={'250px'}/>
            </div>
            <div
              className="py-5 px-2 bg-gray-100 text-center font-bold"
              style={{
                fontSize: '14px'
              }}
            >
              <p>Silahkan untuk mengunggah berkas-berkas berikut</p>
              <p>Terutama berkas dengan status WAJIB</p>
            </div>
            {errors.length > 0 && (
              <div
                className="p-3 space-y-5 bg-red-600 text-white"
              >
                <ul>
                  {errors.map(err => (
                    <li className="py-0">{err}</li>
                  ))}
                </ul>
              </div>
            )}
            <div
              className="py-5 border-t border-b"
            >
              {documents.map(doc => (
                <div
                  className="w-full border-b border-gray-200 p-2"
                >
                  <div
                    className={
                      "w-full py-3 flex items-center rounded-md " + 
                      (isPhone(screenSize.width) ? " flex-col " : "px-5")
                    }
                  >
                    <span 
                      className={
                        "flex flex-1 items-center uppercase " +
                        (isPhone(screenSize.width) ? " justify-center " : "  text-left ")
                      }
                    >
                      {
                        toUploadDocs.find(d => d.idDocument == doc.idDocument) && screenSize.width > 798 ?
                          (<AiOutlineCheckCircle className="h-5 w-5 mr-2 text-green-600" />)
                          :
                          (<span className="h-5 w-5 mr-2"></span>)
                      }

                      {doc.namaDocument}{doc.isMandatory ? ' (WAJIB) ' : ''}
                    </span>
                    <div
                      className={
                        "flex space-x-2 " +
                        (isPhone(screenSize.width) ? " justify-center py-2 " : " justify-end ")
                      }
                      style={{
                        width: "300px"
                      }}
                    >
                      {
                        toUploadDocs.find(d => d.idDocument == doc.idDocument) &&
                        (
                          <>
                            <div className="text-sm flex items-center">
                              <button
                                className="p-2 bg-red-100 text-red-900 rounded-full outline-none hover:bg-red-200 hover:shadow-lg"
                                title={"Hapus dokumen " + doc.name}
                                onClick={() => onRemoveSelectedFile(doc.idDocument)}
                              >
                                <FaTimes className="w-5 h-5" />
                              </button>
                            </div>
                          </>
                        )
                      }
                      <div 
                        className={
                          "text-sm " +
                          (isPhone(screenSize.width) ? " flex justify-center " : "")
                        }
                      >
                        <button
                          className="p-3 bg-blue-100 text-blue-900 rounded-md outline-none hover:bg-blue-200 hover:shadow-md"
                          title={"pilih dokumen " + doc.namaDocument}
                          onClick={() => setUploadDocumentDialog({
                            isOpen: true,
                            selectedDocument: doc
                          })}
                        >
                          Pilih Dokumen
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              className="py-5 flex justify-center px-2"
            >
              <div
                className={
                  "px-10 space-y-5 "+
                  (isPhone(screenSize.width) ? " w-full  " : " w-2/3 ")
                }
              >
                <button
                  className={
                    "w-full py-1.5 rounded-md bg-blue-500 text-white "
                  }
                  style={{
                    fontSize: '14px'
                  }}
                  onClick={onFinish}
                >
                  Unggah Berkas
                </button>
                <button
                  className="w-full border border-blue-500 py-1.5 rounded-md hover:bg-blue-500 hover:text-white"
                  style={{
                    fontSize: '14px'
                  }}
                  onClick={onLogout}
                >
                  Keluar
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    </>
  )


}

export default DocumentPage